// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.swiftref-badge {
    box-sizing: border-box;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0 var(--spacing-05);
    border-radius: 50%;
    color: var(--text-ondark);
    height: var(--spacing-20);
    padding: 0 var(--spacing-05);
    font-family: var( --caption-regular-font-family), sans-serif;
    font-size: var(--caption-regular-font-size);
    letter-spacing: var(--caption-regular-letter-spacing);
    line-height: var(--caption-regular-line-height);
    font-weight: var(--caption-regular-font-weight);
}
.swiftref-badge.text {
    border-radius: var(--spacing-05);
    padding: 0 var(--spacing-10);
    height: var(--spacing-25);
    color: var(--text-default);
    display: inline-flex;
    align-items: center;
    width: fit-content;
}
.swiftref-badge:empty {
    width: 6px;
    height: 6px;
    padding: unset;
}

:host([state="info"]) .swiftref-badge.text {
    background: var(--background-medium);
    border: 1px solid var(--border-medium);
}
:host([state="error"]) .swiftref-badge.text {
    background: var(--background-error-light);
}
:host([state="success"]) .swiftref-badge.text {
    background: var(--background-success);
    border: 1px solid var(--border-success);
}
:host([state="warning"]) .swiftref-badge.text {
    background: var(--background-warning);
    border: 1px solid var(--border-warning-light);
}
:host([state="progress"]) .swiftref-badge.text {
    background: var(--background-pending);
    border: 1px solid var(--border-pending);
}
:host([state="inverse"]) .swiftref-badge.text {
    background: var(--background-inverse);
    border: 1px solid var(--border-medium);
    color: var(--text-ondark);
}
/*dot badge*/
:host([state="info"]) .swiftref-badge {
    background: var(--icon-light);
}
:host([state="error"]) .swiftref-badge {
    background: var(--icon-error);
}
:host([state="success"]) .swiftref-badge {
    background: var(--icon-success);
}
:host([state="warning"]) .swiftref-badge {
    background: var(--icon-warning);
}
:host([state="progress"]) .swiftref-badge {
    background: var(--icon-pending);
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/badge/style/index.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,4BAA4B;IAC5B,4DAA4D;IAC5D,2CAA2C;IAC3C,qDAAqD;IACrD,+CAA+C;IAC/C,+CAA+C;AACnD;AACA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,yBAAyB;IACzB,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,qCAAqC;IACrC,uCAAuC;AAC3C;AACA;IACI,qCAAqC;IACrC,6CAA6C;AACjD;AACA;IACI,qCAAqC;IACrC,uCAAuC;AAC3C;AACA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,yBAAyB;AAC7B;AACA,YAAY;AACZ;IACI,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,+BAA+B;AACnC","sourcesContent":["\n.swiftref-badge {\n    box-sizing: border-box;\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    margin: 0 var(--spacing-05);\n    border-radius: 50%;\n    color: var(--text-ondark);\n    height: var(--spacing-20);\n    padding: 0 var(--spacing-05);\n    font-family: var( --caption-regular-font-family), sans-serif;\n    font-size: var(--caption-regular-font-size);\n    letter-spacing: var(--caption-regular-letter-spacing);\n    line-height: var(--caption-regular-line-height);\n    font-weight: var(--caption-regular-font-weight);\n}\n.swiftref-badge.text {\n    border-radius: var(--spacing-05);\n    padding: 0 var(--spacing-10);\n    height: var(--spacing-25);\n    color: var(--text-default);\n    display: inline-flex;\n    align-items: center;\n    width: fit-content;\n}\n.swiftref-badge:empty {\n    width: 6px;\n    height: 6px;\n    padding: unset;\n}\n\n:host([state=\"info\"]) .swiftref-badge.text {\n    background: var(--background-medium);\n    border: 1px solid var(--border-medium);\n}\n:host([state=\"error\"]) .swiftref-badge.text {\n    background: var(--background-error-light);\n}\n:host([state=\"success\"]) .swiftref-badge.text {\n    background: var(--background-success);\n    border: 1px solid var(--border-success);\n}\n:host([state=\"warning\"]) .swiftref-badge.text {\n    background: var(--background-warning);\n    border: 1px solid var(--border-warning-light);\n}\n:host([state=\"progress\"]) .swiftref-badge.text {\n    background: var(--background-pending);\n    border: 1px solid var(--border-pending);\n}\n:host([state=\"inverse\"]) .swiftref-badge.text {\n    background: var(--background-inverse);\n    border: 1px solid var(--border-medium);\n    color: var(--text-ondark);\n}\n/*dot badge*/\n:host([state=\"info\"]) .swiftref-badge {\n    background: var(--icon-light);\n}\n:host([state=\"error\"]) .swiftref-badge {\n    background: var(--icon-error);\n}\n:host([state=\"success\"]) .swiftref-badge {\n    background: var(--icon-success);\n}\n:host([state=\"warning\"]) .swiftref-badge {\n    background: var(--icon-warning);\n}\n:host([state=\"progress\"]) .swiftref-badge {\n    background: var(--icon-pending);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
